// Baseado na lista de produtos fornecida pela COOPDELTA
export const productList = [
    {
      id: 'caranguejo-natura',
      name: 'Caranguejo In-Natura Congelado',
      unit: 'kg',
      category: 'caranguejo'
    },
    {
      id: 'caranguejo-pre-cozido',
      name: 'Caranguejo Pré-Cozido Congelado',
      unit: 'kg',
      category: 'caranguejo'
    },
    {
      id: 'clast-caranguejo',
      name: 'Clast de Caranguejo Pré-Cozido Congelado',
      unit: 'kg',
      category: 'caranguejo'
    },
    {
      id: 'carne-caranguejo',
      name: 'Carne de Caranguejo Pré-Cozido Congelado',
      unit: 'kg',
      category: 'caranguejo'
    },
    {
      id: 'pinca-caranguejo',
      name: 'Pinça de Caranguejo Pré-Cozido Congelado',
      unit: 'kg',
      category: 'caranguejo'
    },
    {
      id: 'patola-caranguejo',
      name: 'Patola de Caranguejo Pré-Cozido Congelado',
      unit: 'un',
      category: 'caranguejo'
    },
    {
      id: 'farinha-caranguejo',
      name: 'Farinha de Caranguejo',
      unit: 'kg',
      category: 'caranguejo'
    },
    {
      id: 'siri-azul-natura',
      name: 'Siri Azul In-Natura Congelado',
      unit: 'kg',
      category: 'siri'
    },
    {
      id: 'siri-azul-pre-cozido',
      name: 'Siri Azul Pré-Cozido Congelado',
      unit: 'kg',
      category: 'siri'
    },
    {
      id: 'siri-vermelho-natura',
      name: 'Siri Vermelho In-Natura Congelado',
      unit: 'kg',
      category: 'siri'
    },
    {
      id: 'siri-vermelho-pre-cozido',
      name: 'Siri Vermelho Pré-Cozido Congelado',
      unit: 'kg',
      category: 'siri'
    },
    {
      id: 'ostra-raiz-media',
      name: 'Ostra de Raiz Média In-Natura Congelada',
      unit: 'kg',
      category: 'ostra'
    },
    {
      id: 'ostra-raiz-grande',
      name: 'Ostra de Raiz Grande In-Natura Congelada',
      unit: 'kg',
      category: 'ostra'
    },
    {
      id: 'ostra-pedra-media',
      name: 'Ostra de Pedra Média In-Natura Congelada',
      unit: 'kg',
      category: 'ostra'
    },
    {
      id: 'ostra-pedra-grande',
      name: 'Ostra de Pedra Grande In-Natura Congelada',
      unit: 'kg',
      category: 'ostra'
    },
    {
      id: 'camarao-praia-medio',
      name: 'Camarão de Praia Médio In-Natura Congelado',
      unit: 'kg',
      category: 'camarao'
    },
    {
      id: 'camarao-praia-grande',
      name: 'Camarão de Praia Grande In-Natura Congelado',
      unit: 'kg',
      category: 'camarao'
    },
    {
      id: 'pescada-amarela',
      name: 'Pescada Amarela In-Natura',
      unit: 'kg',
      category: 'peixe'
    },
    {
      id: 'tainha',
      name: 'Tainha In-Natura',
      unit: 'kg',
      category: 'peixe'
    }
  ];
  
  // Categorias de produtos
  export const productCategories = [
    {
      id: 'caranguejo',
      name: 'Caranguejo',
      color: 'bg-orange-100'
    },
    {
      id: 'siri',
      name: 'Siri',
      color: 'bg-blue-100'
    },
    {
      id: 'ostra',
      name: 'Ostra',
      color: 'bg-gray-100'
    },
    {
      id: 'camarao',
      name: 'Camarão',
      color: 'bg-amber-100'
    },
    {
      id: 'peixe',
      name: 'Peixes',
      color: 'bg-green-100'
    }
  ];